import { Tabs } from 'antd';
import qs from 'qs';
import { RouteComponentProps } from 'react-router-dom';
import CollaboratorListContainer from './CollaboratorListContainer';
import PartnerInvitationListContainer from './PartnerInvitationListContainer';
import PartnerListContainer from './PartnerListContainer';

const { TabPane } = Tabs;

interface PartnerManagementContainerProps {
  enterpriseId: string;
  projectId: string;
}
function PartnerManagementContainer({
  history,
  match,
  ...rest
}: RouteComponentProps<PartnerManagementContainerProps>) {
  const { projectId } = match.params;
  const { tab } = qs.parse(window.location.search, {
    ignoreQueryPrefix: true,
  });
  let title;
  if (projectId) {
    title = '공사참여자';
  } else {
    title = '거래처 관리';
  }

  return (
    <>
      <h2>{title}</h2>
      <Tabs defaultActiveKey={tab as string} destroyInactiveTabPane>
        <TabPane tab="직원" key="1">
          <CollaboratorListContainer
            history={history}
            match={match}
            {...rest}
          />
        </TabPane>
        <TabPane tab="업체" key="2">
          <PartnerListContainer history={history} match={match} {...rest} />
        </TabPane>
        {/* {!projectId && (
          <TabPane tab="지원서" key="3">
            <PrequalificationListContainer
              history={history}
              match={match}
              {...rest}
            />
          </TabPane>
        )} */}
        {/* {!projectId && (
          <TabPane tab="모집공고" key="4">
            <PrequalificationConfigDetailContainer
              history={history}
              match={match}
              {...rest}
            />
          </TabPane>
        )} */}
        {!projectId && (
          <TabPane tab="초대하기" key="5">
            <PartnerInvitationListContainer
              history={history}
              match={match}
              {...rest}
            />
          </TabPane>
        )}
      </Tabs>
    </>
  );
}

export default PartnerManagementContainer;
